import React from 'react';
import CategoryMenuContainer from './CategoryMenuContainer';
import { styled } from 'linaria/react';

const Nav = styled('nav')`
  padding: 0;
  border: none;
  width: 100%;
  button {
    background: none;
    color: #666;
  }

  .menu-container {
    margin-top: 0;
  }
`;

export function CategoryMenu({ data }) {
  return (
    <Nav>
      <div key={'menuContainerPosed'} className="menu-container">
        <CategoryMenuContainer queryData={data} />
      </div>
    </Nav>
  );
}
